import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {CommonService} from "../../shared/service/common.service";
import {UserService} from "../../shared/service/user.service";
import {NavController} from "@ionic/angular";
import {NavigationService} from "../../shared/service/navigation.service";

@Component({
  selector: 'app-register',
  templateUrl: './register.page.html',
  styleUrls: ['./register.page.scss'],
})
export class RegisterPage implements OnInit {

  registerProgress: boolean;
  registerForm: FormGroup = this.fb.group({
    email: [undefined, [Validators.required, Validators.email]],
    password: [undefined, [Validators.required]],
    name: [undefined, [Validators.required]],
    lastName: [undefined, [Validators.required]],
    policyAccepted: [false]
  });

  constructor(private fb: FormBuilder,
              private userService: UserService,
              private navigationService: NavigationService,
              private commonService: CommonService) {
  }

  ngOnInit() {
  }

  onTogglePolicy() {
    this.registerForm.patchValue({policyAccepted: !this.registerForm.value.policyAccepted});
  }

  onRegister() {

    const {email, password, name, lastName, policyAccepted} = this.registerForm.value;
    if (!policyAccepted) {
      this.commonService.presentAlertMsg('Policy di registrazione', 'Per completare la registrazione, è necessario accettare i Termini di Servizio e l\'Informativa sulla Privacy.');
      return;
    }

    this.registerProgress = true;

    this.userService.register({
      email,
      password,
      name,
      lastName
    }).subscribe((res) => {
      this.registerProgress = false;
      this.commonService.presentAlertMsg('Verifica email', 'Abbiamo inviato un\'email di conferma. Controlla la tua casella di posta per verificare l\'indirizzo.');
      this.navigationService.goRoot(['mail-verified']);
      this.navigationService.closeModal();

    }, (error) => {
      this.registerProgress = false;
      this.commonService.presentAlertMsg("Error occured", 'APP_ERRORS.' + error?.error?.message);
    });

  }

}
